import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Http from "../../../Common/Http";
import LoaderComponent from "../../../Common/LoaderComponent";

const View = () => {
  const [requisitionData, setRequisitionData] = useState({});
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [departments, setDepartments] = useState([
    { id: 14, name: "Decel Store", user_type: "dstore" },
    { id: 15, name: "General Store", user_type: "gstore" },
    { id: 17, name: "Packaging Store", user_type: "pstore" },
  ]);

  useEffect(() => {
    fetchRequisitionData();
  }, [id]);

  const fetchRequisitionData = () => {
    Http.get(`/product/${id}`)
      .then((res) => {
        setRequisitionData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        Swal.fire("Error!", "Failed to fetch requisition details.", "error");
        setLoading(false);
      });
  };

  const getDepartmentNameById = (departmentId) => {
    const department = departments.find((dept) => dept.id === departmentId);
    return department ? department.name : "N/A";
  };

  const dataList = requisitionData.items || [];

  const print = () => {
    window.print();
  };

  return (
    <div>
      {/* <LoaderComponent loading={loading} /> */}
      <style>
        {`
          @media print {
              body * { visibility: hidden; font-size:10px; }
              .no-print { visibility: hidden !important; }
              #printable-content, #printable-content * { visibility: visible; }
              #printable-content { position: absolute; left: 0; top: 0; width: 100%; }
          }
        `}
      </style>

      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Product Details</h5>
        </div>

        <div className="am-pagebody">
          <div className="card card-primary card-outline">
            <div className="card-header noPrint">
              <div className="row">
                <div className="col-md-7">
                  <h4 className="card-title">
                    Product Code: {requisitionData?.code}
                  </h4>
                </div>
                <div className="col-md-5 text-right">
                  <button className="btn btn-default" onClick={print}>
                    <i className="fa fa-print"></i>
                    &nbsp;Print
                  </button>
                </div>
              </div>
            </div>

            <div className="card-body" id="printable-content">
              <div className="row">
                <div className="col-md-12">
                  <table className="table">
                    <tbody>
                      <tr>
                        <td style={{ border: "none" }} align="center">
                          <img
                            src="https://artisan.projectsample.info/backend/public/image/artisan-logo.jpeg"
                            width="30%"
                            alt="Logo"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <table className="table table-sm">
                    <tbody>
                      <tr>
                        <td>Name: {requisitionData?.name}</td>
                        <td>Department: {requisitionData?.department_art?.name	}</td>
                      </tr>
                       <tr>
                        <td>Unit: {requisitionData?.unit?.name}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                   <table className="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <td align="center" className="py-3" colSpan={8}><h5><u>Purchase Requisition</u></h5></td>
                        </tr>
                      </thead>
                    </table>
                  <table className="table table-bordered table-sm">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Receipt No</th>
                        <th>Department</th>
                        <th>Req. Qty</th>
                        <th>Approved Qty</th>
                        <th>Purchase Type</th>
                        <th>Date</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {requisitionData?.store_purchase_requisition_art_items?.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item?.purchase_requisition_art?.receipt_no}</td>
                          <td>{item?.purchase_requisition_art?.department?.name}</td>
                          <td>{item?.required_qty}</td>
                          <td>{item?.approved_qty}</td>
                          <td>{item?.purchase_requisition_art?.purchase_type}</td>
                          <td>{item?.purchase_requisition_art?.date}</td>
                          <td>{item?.purchase_requisition_art?.status}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

               <div className="row">
                <div className="col-md-12">
                   <table className="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <td align="center" className="py-3" colSpan={8}><h5><u>Direct Purchase</u></h5></td>
                        </tr>
                      </thead>
                    </table>
                  <table className="table table-bordered table-sm">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Receipt NO</th>
                        <th>Vendor Name</th>
                        <th>PO Qty</th>
                        <th>Maximum Allowed Moisture</th>
                        <th>Received Qty</th>
                        <th>Unit Price</th>
                        <th>Total Amount</th>
                        <th>Date</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {requisitionData?.direct_purchase_item?.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item?.direct_purchase?.receipt_no}</td>
                          <td>{item?.direct_purchase?.vendor?.name}</td>
                          <td>{item?.qty }</td> 
                          <td>{item?.moisture }</td> 
                          <td>{item?.received_qty	}</td>
                          <td>{item?.price	}</td>
                          <td>{item?.total_amount	}</td>
                          <td>{item?.direct_purchase?.date	}</td>
                          <td>{item?.direct_purchase?.status	}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

               <div className="row">
                <div className="col-md-12">
                   <table className="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <td align="center" className="py-3" colSpan={8}><h5><u>GRN</u></h5></td>
                        </tr>
                      </thead>
                    </table>
                  <table className="table table-bordered table-sm">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Challan NO</th>
                        <th>Accepted Qty</th>
                        <th>Rejected Qty</th>
                        <th>Moisture Found From QC</th>
                        <th>Challan Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {requisitionData?.grn_items?.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item?.grns?.challan_no}</td>
                          <td>{item?.accepted_qty }</td>
                          <td>{item?.rejected_qty}</td>
                          <td>{item?.moisture	}</td>
                          <td>{item?.grns?.challan_date	}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <table className="table" style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td width="30%" align="center">
                          <br />
                          <br />
                          <br />
                          ......................................................
                          <br />
                          Prepared By
                        </td>
                        <td width="30%" align="center">
                          <br />
                          <br />
                          <br />
                          ......................................................
                          <br />
                          Checked By
                        </td>
                        <td width="30%" align="center">
                          <br />
                          <br />
                          <br />
                          ......................................................
                          <br />
                          Approved By
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default View;
